import { Allergen } from "Domain/Model/Allergen/Allergen";

export const CREATE_ALLERGEN_SUCCESS = 'CREATE_ALLERGEN_SUCCESS';

export const createAllergenSuccess = (payload: Record<string, Allergen> ) => ({
    type: CREATE_ALLERGEN_SUCCESS,
    payload,
});